(() => {
  const storageKey = 'ashbourne-cart-expires-at';
  const duration = 10 * 60 * 1000;
  const timerSelector = '[data-cart-expiration-timer]';
  const countdownSelector = '[data-cart-expiration-countdown]';
  let intervalId = null;
  let memoryExpiry = null;
  let isClearingCart = false;

  const getStoredExpiry = () => {
    try {
      const value = Number(window.localStorage.getItem(storageKey));
      return Number.isFinite(value) && value > 0 ? value : null;
    } catch (error) {
      return memoryExpiry;
    }
  };

  const storeExpiry = (value) => {
    memoryExpiry = value;
    try {
      window.localStorage.setItem(storageKey, String(value));
    } catch (error) {
      // The in-memory value keeps the timer working when storage is unavailable.
    }
  };

  const removeStoredExpiry = () => {
    memoryExpiry = null;
    try {
      window.localStorage.removeItem(storageKey);
    } catch (error) {
      // Nothing else is required when storage is unavailable.
    }
  };

  const stopTimer = () => {
    if (intervalId !== null) {
      window.clearInterval(intervalId);
      intervalId = null;
    }
  };

  const formatRemainingTime = (remaining) => {
    const totalSeconds = Math.max(0, Math.ceil(remaining / 1000));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  const updateCountdowns = (expiry) => {
    const remaining = expiry - Date.now();
    const formattedTime = formatRemainingTime(remaining);

    document.querySelectorAll(countdownSelector).forEach((element) => {
      if (element.textContent !== formattedTime) element.textContent = formattedTime;
    });

    if (remaining <= 0) clearCart();
  };

  const clearCart = async () => {
    if (isClearingCart) return;
    isClearingCart = true;
    stopTimer();

    try {
      const clearUrl = window.routes?.cart_clear_url || `${window.Shopify?.routes?.root || '/'}cart/clear.js`;
      const response = await fetch(clearUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) throw new Error('Cart could not be cleared');

      removeStoredExpiry();
      window.location.reload();
    } catch (error) {
      isClearingCart = false;
      window.setTimeout(syncTimer, 1000);
    }
  };

  const syncTimer = () => {
    const timerElements = document.querySelectorAll(timerSelector);

    if (timerElements.length === 0) {
      stopTimer();
      removeStoredExpiry();
      return;
    }

    let expiry = getStoredExpiry();
    if (expiry === null) {
      expiry = Date.now() + duration;
      storeExpiry(expiry);
    }

    updateCountdowns(expiry);

    if (expiry <= Date.now() || intervalId !== null) return;
    intervalId = window.setInterval(() => updateCountdowns(expiry), 1000);
  };

  const nodeContainsTimer = (node) => {
    if (!(node instanceof Element)) return false;
    return node.matches(timerSelector) || Boolean(node.querySelector(timerSelector));
  };

  const observeCartChanges = () => {
    const observer = new MutationObserver((mutations) => {
      const timerChanged = mutations.some((mutation) =>
        [...mutation.addedNodes, ...mutation.removedNodes].some(nodeContainsTimer)
      );

      if (timerChanged) syncTimer();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  const initialize = () => {
    syncTimer();
    observeCartChanges();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
